import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  leadIcon: css`
    height: ${spacing(5)};
  `,
  trailIcon: css`
    height: ${spacing(3)};
  `,
}
